/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".mat-form-field[_ngcontent-%COMP%]{width:100%;min-width:300px}.reset-password-buttons[_ngcontent-%COMP%]{margin-top:24px;display:flex;flex-direction:row;justify-content:space-between}.reset-password-buttons[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{flex:.49}h3[_ngcontent-%COMP%]{margin-bottom:32px}"];
export { styles as styles };
